import { DefaultState } from 'store/reducers/types';

export const READ_MY_TASKS_DATA_REQUEST = 'READ_MY_TASKS_DATA_REQUEST';
export const READ_MY_TASKS_DATA_SUCCESS = 'READ_MY_TASKS_DATA_SUCCESS';
export const READ_MY_TASKS_DATA_FAILURE = 'READ_MY_TASKS_DATA_FAILURE';

export type MyTasksData = {
  overdue: number;
  today: number;
};

export type MyTasksState = DefaultState & {
  contents?: MyTasksData;
};

interface ReadMyTasksDataRequest {
  type: typeof READ_MY_TASKS_DATA_REQUEST;
};

interface ReadMyTasksDataSuccess {
  type: typeof READ_MY_TASKS_DATA_SUCCESS,
  contents: MyTasksData;
}

interface ReadMyTasksDataFailure {
  type: typeof READ_MY_TASKS_DATA_FAILURE;
}

export type MyTasksActionTypes = ReadMyTasksDataRequest | ReadMyTasksDataSuccess | ReadMyTasksDataFailure;